import { STALE_TIME } from "../../misc/config";

const baseOptions = {
  staleTime: STALE_TIME,
  refetchInterval: STALE_TIME,
};
export default baseOptions;
